module.exports = __webpack_public_path__ + "img/camera-send.ab627b16.svg";